export default __webpack_public_path__ + "static/Dennis.Johnson_social-3668ffe51c48a8a8d38e63a6e197a9ea.jpg";